export var ApiMessageType;
(function (ApiMessageType) {
  ApiMessageType["SYSTEM_STATISTIC"] = "system.statistic"
  ApiMessageType["SYSTEM_LOG"] = "system.log"
  ApiMessageType["APPLICATION_FINISH"] = "system.application.finish"
  ApiMessageType["POWER_CONTROL"] = "system.power.control"
  ApiMessageType["CAMERA_CONTROL_ERROR"] = "camera.control.error"
  ApiMessageType["CAMERA_CONTROL_REQUEST"] = "camera.control.request"
  ApiMessageType["CAMERA_CONTROL_RESPONSE"] = "camera.control.response"
  ApiMessageType["DRIVE_STATUS"] = "system.drive.status"
  ApiMessageType["DRIVE_MODE"] = "system.drive.mode"
  ApiMessageType["DRIVE_CHARGE"] = "system.drive.charge"
  ApiMessageType["DRIVE_CONTROL"] = "system.drive.control"
  ApiMessageType["DISPENSER_DISPENSE"] = "dispenser.dispense"
  ApiMessageType["DISPENSER_FULL_STATUS"] = "dispenser.full_status"
  ApiMessageType["FILESYSTEM_CONTROL_REQUEST"] = "filesystem.control.request"
  ApiMessageType["FILESYSTEM_CONTROL_RESPONSE"] = "filesystem.control.response"
  ApiMessageType["READER_RFID_REQUEST"] = "reader.rfid.request"
  ApiMessageType["READER_RFID_RESPONSE"] = "reader.rfid.response"
  ApiMessageType["QUESTION_CANCEL"] = "dialog.question.cancel"
  ApiMessageType["QUESTION_NEW"] = "dialog.question.new"
  ApiMessageType["QUESTION_ANSWER"] = "dialog.question.answer"
  ApiMessageType["SAY"] = "dialog.say"
  ApiMessageType["REPLIC_GET"] = "dialog.replica.get"
  ApiMessageType["REPLIC_LOAD"] = "dialog.replica.load"
  ApiMessageType["REPLIC_EXTRA_LOAD"] = "dialog.replica.extra.load"
  ApiMessageType["ANSWER_LOAD"] = "dialog.answer.load"
  ApiMessageType["GREETING_LOAD"] = "dialog.greeting.load"
  ApiMessageType["USER_SAID"] = "dialog.user.said"
  ApiMessageType["ROBOT_REPLIC_START"] = "dialog.robot.replic.start"
  ApiMessageType["ROBOT_REPLIC_FINISH"] = "dialog.robot.replic.finish"
  ApiMessageType["ROBOT_REPLIC_ABORT"] = "dialog.robot.replic.abort"
  ApiMessageType["USER_ACTION"] = "dialog.action"
  ApiMessageType["INTERACTION_STATE"] = "system.interaction.state"
  ApiMessageType["INTERACTION_CONTROL"] = "system.interaction.control"
  ApiMessageType["ENVIRONMENT_GET"] = "system.environment.get"
  ApiMessageType["ENVIRONMENT_LOAD"] = "system.environment.load"
  ApiMessageType["USER_HAS"] = "user.has.user"
  ApiMessageType["USER_LOST"] = "user.lost.user"
  ApiMessageType["USER_DATABASE_REQUEST"] = "database.user.request"
  ApiMessageType["USER_DATABASE_RESPONSE"] = "database.user.response"
  ApiMessageType["SETTINGS_UPDATE"] = "system.settings.update"
  ApiMessageType["SETTINGS_GET"] = "system.settings.get"
  ApiMessageType["SETTINGS_LOAD"] = "system.settings.load"
  ApiMessageType["SYSTEM_SOUND_PROPERTIES"] = "system.sound.properties"
  ApiMessageType["SYSTEM_SOUND_LOAD"] = "system.sound.load"
  ApiMessageType["SYSTEM_LANGUAGE"] = "system.language"
  ApiMessageType["SYSTEM_LANGUAGE_SET"] = "system.language.set"
  ApiMessageType["SYSTEM_PLAY_EXTERNAL"] = "system.play.external"
  ApiMessageType["SYSTEM_PLAY_STATUS"] = "system.play.status"
  ApiMessageType["RECORD_AUDIO_REQUEST"] = "record.audio.request"
  ApiMessageType["RECORD_AUDIO_RESPONSE"] = "record.audio.response"
  ApiMessageType["MAIL_SENDER_REQUEST"] = "mail.sender.request"
  ApiMessageType["MAIL_SENDER_RESPONSE"] = "mail.sender.response"
  ApiMessageType["GENERAL_SETTED"] = "system.general.setted"
  ApiMessageType["FACE_RECOGNIZE_INFO"] = "face.recognize.info"
  ApiMessageType["FACE_RECOGNIZE_GENERAL"] = "face.recognize.general"
  ApiMessageType["FACE_RECOGNIZE_CONTROL"] = "face.recognize.control"
  ApiMessageType["FACE_ADD_STATUS"] = "face.add.status"
  ApiMessageType["FACE_GENERAL_FRAME"] = "face.general.frame"
  ApiMessageType["GENERAL_TOUCH"] = "system.general.touch"
  ApiMessageType["FACE_MATCH_SCORE"] = "face.match.score"
  ApiMessageType["SYSTEM_PUSH_RESPONSE"] = "system.push.response"
  ApiMessageType["SYSTEM_PUSH_ADDED"] = "system.push.added"
  ApiMessageType["SYSTEM_PUSH_REQUEST"] = "system.push.request"
  ApiMessageType["SYSTEM_PUSH_NUMBER"] = "system.push.number"
  ApiMessageType["KEYBOARD_CONTROL_REQUEST"] = "keyboard.control.request"
  ApiMessageType["KEYBOARD_CONTROL_RESPONSE"] = "keyboard.control.response"
  ApiMessageType["CUSTOM_EVENT_CORE"] = "system.custom.event.core"
  ApiMessageType["CUSTOM_EVENT_JS"] = "system.custom.event.js"
  ApiMessageType["SIP_DTMF_RESPONSE"] = "sip.dtmf.response"
  ApiMessageType["SIP_SIP_STATUS"] = "sip.sip.status"
  ApiMessageType["SIP_CONTROL"] = "sip.control"
  ApiMessageType["SIP_EVENTS"] = "sip.events"
  ApiMessageType["PRINT_LOW_PAPER"] = "printer.paper.low"
  ApiMessageType["PRINT_SUCCESS"] = "printer.success"
  ApiMessageType["PRINT_STATE_INFO"] = "printer.state.info"
  ApiMessageType["PRINT_ERROR"] = "printer.error"
  ApiMessageType["PRINT_NO_PAPER"] = "printer.nopaper"
  ApiMessageType["PRINT_NO_PRINTER"] = "printer.noprinter"
  ApiMessageType["PRINT"] = "printer.print"
  ApiMessageType["PRINT_STATE"] = "printer.state"
  ApiMessageType["SCRIPTS_START_RESULT"] = "system.scripts.start.result"
  ApiMessageType["SCRIPTS_END"] = "system.scripts.end"
  ApiMessageType["SCRIPTS_CONTROL"] = "system.scripts.control"
  ApiMessageType["READER_BARCODE_REQUEST"] = "reader.barcode.request"
  ApiMessageType["READER_BARCODE_RESPONSE"] = "reader.barcode.response"
  ApiMessageType["OPERATOR_CALL_RESPONSE"] = "operator.call.response"
  ApiMessageType["OPERATOR_CONTROL_STATUS"] = "operator.control.status"
  ApiMessageType["OPERATOR_CALL_REQUEST"] = "operator.call.request"
  ApiMessageType["PRINT_PHOTO"] = "printer.photo.print"
  ApiMessageType["PRINT_PHOTO_CLEAR_QUEUE"] = "printer.photo.clear.queue"
  ApiMessageType["PRINT_PHOTO_STATE"] = "printer.photo.state"
  ApiMessageType["PRINT_PHOTO_FINISH"] = "printer.photo.finish"
  ApiMessageType["PRINT_PHOTO_SUCCESS"] = "printer.photo.success"
  ApiMessageType["PRINT_PHOTO_ERROR"] = "printer.photo.error"
  ApiMessageType["PRINT_PHOTO_NO_PRINTER"] = "printer.photo.noprinter"
  ApiMessageType["PRINT_PHOTO_STATE_INFO"] = "printer.photo.state.info"
  ApiMessageType["SCANNER_PASSPORT_RESPONSE"] = "scanner.passport.response"
  ApiMessageType["SCANNER_PASSPORT_REQUEST"] = "scanner.passport.request"
  ApiMessageType["SCANNER_PASSPORT_ERROR"] = "scanner.passport.error"
  ApiMessageType["SCANNER_PASSPORT_STATE"] = "scanner.passport.state"
  ApiMessageType["SCANNER_PASSPORT_FINISH"] = "scanner.passport.finish"
  ApiMessageType["PAYMENT_TERMINAL_REQUEST"] = "payment.terminal.request"
  ApiMessageType["PAYMENT_TERMINAL_RESPONSE"] = "payment.terminal.response"
  ApiMessageType["PAYMENT_TERMINAL_STATUS"] = "payment.terminal.status"
  ApiMessageType["SCANNER_DOCUMENT_REQUEST"] = "scanner.document.request"
  ApiMessageType["SCANNER_DOCUMENT_RESPONSE"] = "scanner.document.response"
  ApiMessageType["SCANNER_DOCUMENT_ERROR"] = "scanner.document.error"
  ApiMessageType["SCANNER_DOCUMENT_STATE"] = "scanner.document.state"
  ApiMessageType["SCANNER_DOCUMENT_PROGRESS"] = "scanner.document.progress"
  ApiMessageType["SCANNER_DOCUMENT_FINISH"] = "scanner.document.finish"
  ApiMessageType["FINGERPRINT_SCANNER_REQUEST"] = "scanner.fingerprint.request"
  ApiMessageType["FINGERPRINT_SCANNER_RESPONSE"] = "scanner.fingerprint.response"
  ApiMessageType["FINGERPRINT_SCANNER_ERROR"] = "scanner.fingerprint.error"
  ApiMessageType["FINGERPRINT_SCANNER_STATE"] = "scanner.fingerprint.state"
  ApiMessageType["FINGERPRINT_SCANNER_STATUS"] = "scanner.fingerprint.status"
  ApiMessageType["FINGERPRINT_SCANNER_FINISH"] = "scanner.fingerprint.finish"
})(ApiMessageType || (ApiMessageType = {}))
